import { render, staticRenderFns } from "./Invited.vue?vue&type=template&id=4b718104&scoped=true"
import script from "./Invited.vue?vue&type=script&lang=js"
export * from "./Invited.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b718104",
  null
  
)

export default component.exports